const filtersConfig = [
  {
    pagename: "CustomerConfiguration",
    filters: {
      State: {
        sequence: 1,
        type: "select",
        label: "State",
        mandatory: true,
        parentFilter: null,
        fieldName: "statename",
        placeholder: "Select State*",
      },
      City: {
        sequence: 2,
        type: "select",
        label: "City",
        mandatory: false,
        parentFilter: "State",
        fieldName: "City",
        placeholder: "Select City",
      },
    },
    fieldMapping: {
      State: "statename",
      City: "City",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "SiteConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      State: {
        sequence: 2,
        type: "select",
        label: "State",
        mandatory: false,
        parentFilter: "Customer",
        fieldName: "statename",
        placeholder: "Select State",
      },
      City: {
        sequence: 3,
        type: "select",
        label: "City",
        mandatory: false,
        parentFilter: "State",
        fieldName: "City",
        placeholder: "Select City",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "ZoneConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      State: {
        sequence: 2,
        type: "select",
        label: "State",
        mandatory: false,
        parentFilter: "Customer",
        fieldName: "statename",
        placeholder: "Select State",
      },
      City: {
        sequence: 3,
        type: "select",
        label: "City",
        mandatory: false,
        parentFilter: "State",
        fieldName: "City",
        placeholder: "Select City",
      },
      Site: {
        sequence: 4,
        type: "select",
        label: "Site",
        mandatory: true,
        parentFilter: "City",
        fieldName: "SiteName",
        placeholder: "Select Site*",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "EmergencyContactConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      State: {
        sequence: 2,
        type: "select",
        label: "State",
        mandatory: false,
        parentFilter: "Customer",
        fieldName: "statename",
        placeholder: "Select State",
      },
      City: {
        sequence: 3,
        type: "select",
        label: "City",
        mandatory: false,
        parentFilter: "State",
        fieldName: "City",
        placeholder: "Select City",
      },
      Site: {
        sequence: 4,
        type: "select",
        label: "Site",
        mandatory: false,
        parentFilter: "City",
        fieldName: "SiteName",
        placeholder: "Select Site",
      },
      Zone: {
        sequence: 5,
        type: "select",
        label: "Zone",
        mandatory: false,
        parentFilter: "Site",
        fieldName: "ZoneName",
        placeholder: "Select Zone",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
      Zone: "ZoneName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "EmergencyContactMappingConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      State: {
        sequence: 2,
        type: "select",
        label: "State",
        mandatory: false,
        parentFilter: "Customer",
        fieldName: "statename",
        placeholder: "Select State",
      },
      City: {
        sequence: 3,
        type: "select",
        label: "City",
        mandatory: false,
        parentFilter: "State",
        fieldName: "City",
        placeholder: "Select City",
      },
      Site: {
        sequence: 4,
        type: "select",
        label: "Site",
        mandatory: true,
        parentFilter: "City",
        fieldName: "SiteName",
        placeholder: "Select Site",
      },
      Zone: {
        sequence: 5,
        type: "select",
        label: "Zone",
        mandatory: false,
        parentFilter: "Site",
        fieldName: "ZoneName",
        placeholder: "Select Zone",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
      Zone: "ZoneName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "InterfaceConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      State: {
        sequence: 2,
        type: "select",
        label: "State",
        mandatory: false,
        parentFilter: "Customer",
        fieldName: "statename",
        placeholder: "Select State",
      },
      City: {
        sequence: 3,
        type: "select",
        label: "City",
        mandatory: false,
        parentFilter: "State",
        fieldName: "City",
        placeholder: "Select City",
      },
      Site: {
        sequence: 4,
        type: "select",
        label: "Site",
        mandatory: true,
        parentFilter: "City",
        fieldName: "SiteName",
        placeholder: "Select Site*",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "DeviceConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      State: {
        sequence: 2,
        type: "select",
        label: "State",
        mandatory: false,
        parentFilter: "Customer",
        fieldName: "statename",
        placeholder: "Select State",
      },
      City: {
        sequence: 3,
        type: "select",
        label: "City",
        mandatory: false,
        parentFilter: "State",
        fieldName: "City",
        placeholder: "Select City",
      },
      Site: {
        sequence: 4,
        type: "select",
        label: "Site",
        mandatory: true,
        parentFilter: "City",
        fieldName: "SiteName",
        placeholder: "Select Site*",
      },
      Interface: {
        sequence: 6,
        type: "select",
        label: "Interface",
        mandatory: true,
        parentFilter: "Site",
        fieldName: "InterfaceName",
        placeholder: "Select Interface*",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
      Interface: "InterfaceName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "RecordingConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      // State: {
      //   sequence: 2,
      //   type: "select",
      //   label: "State",
      //   mandatory: false,
      //   parentFilter: "Customer",
      //   fieldName: "statename",
      //   placeholder: "Select State",
      // },
      // City: {
      //   sequence: 3,
      //   type: "select",
      //   label: "City",
      //   mandatory: false,
      //   parentFilter: "State",
      //   fieldName: "City",
      //   placeholder: "Select City",
      // },
      Site: {
        sequence: 2,
        type: "select",
        label: "Site",
        mandatory: true,
        parentFilter: "Customer",
        fieldName: "SiteName",
        placeholder: "Select Site*",
      },
      Interface: {
        sequence: 6,
        type: "select",
        label: "Interface",
        mandatory: true,
        parentFilter: "Site",
        fieldName: "InterfaceName",
        placeholder: "Select Interface*",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
      Interface: "InterfaceName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "DiscoverDevicesConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      Site: {
        sequence: 2,
        type: "select",
        label: "Site",
        mandatory: false,
        parentFilter: "Customer",
        fieldName: "SiteName",
        placeholder: "Select Site",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
      Interface: "InterfaceName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  },
  {
    pagename: "ViewDiscoverDevicesConfiguration",
    filters: {
      Customer: {
        sequence: 1,
        type: "select",
        label: "Customer",
        mandatory: true,
        parentFilter: null,
        fieldName: "ClientName",
        placeholder: "Select Customer*",
      },
      Site: {
        sequence: 2,
        type: "select",
        label: "Site",
        mandatory: true,
        parentFilter: "Customer",
        fieldName: "SiteName",
        placeholder: "Select Site*",
      },
    },
    fieldMapping: {
      Customer: "ClientName",
      State: "statename",
      City: "City",
      Site: "SiteName",
      Interface: "InterfaceName",
    },
    displayConfig: {
      showClearButton: true,
      showApplyButton: true,
      enableSingleSelection: true,
    },
  }
];

export default filtersConfig;
